import _toArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export function isTranspose(coordinate) {
  var _coordinate$getOption = coordinate.getOptions(),
    transformations = _coordinate$getOption.transformations;
  var transposes = transformations.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      type = _ref2[0];
    return type;
  }).filter(function (type) {
    return type === 'transpose';
  });
  return transposes.length % 2 !== 0;
}
export function isPolar(coordinate) {
  var _coordinate$getOption2 = coordinate.getOptions(),
    transformations = _coordinate$getOption2.transformations;
  return transformations.some(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      type = _ref4[0];
    return type === 'polar';
  });
}
export function isRadial(coordinate) {
  var _coordinate$getOption3 = coordinate.getOptions(),
    transformations = _coordinate$getOption3.transformations;
  return (
    // distinguish radial from theta.
    transformations.some(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        type = _ref6[0];
      return type === 'reflect';
    }) && transformations.some(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
        type = _ref8[0];
      return type.startsWith('transpose');
    })
  );
}
export function isHelix(coordinate) {
  var _coordinate$getOption4 = coordinate.getOptions(),
    transformations = _coordinate$getOption4.transformations;
  return transformations.some(function (_ref9) {
    var _ref0 = _slicedToArray(_ref9, 1),
      type = _ref0[0];
    return type === 'helix';
  });
}
export function isParallel(coordinate) {
  var _coordinate$getOption5 = coordinate.getOptions(),
    transformations = _coordinate$getOption5.transformations;
  return transformations.some(function (_ref1) {
    var _ref10 = _slicedToArray(_ref1, 1),
      type = _ref10[0];
    return type === 'parallel';
  });
}
export function isFisheye(coordinate) {
  var _coordinate$getOption6 = coordinate.getOptions(),
    transformations = _coordinate$getOption6.transformations;
  return transformations.some(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 1),
      type = _ref12[0];
    return type === 'fisheye';
  });
}
export function isRadar(coordinate) {
  return isParallel(coordinate) && isPolar(coordinate);
}
export function isCircular(coordinate) {
  return isHelix(coordinate) || isPolar(coordinate);
}
export function isTheta(coordinate) {
  return isPolar(coordinate) && isTranspose(coordinate);
}
export function isNonCartesian(coordinate) {
  return isPolar(coordinate) || isParallel(coordinate) || isRadial(coordinate) || isTheta(coordinate);
}
export function getRadius(coordinate) {
  if (isCircular(coordinate)) {
    var _coordinate$getSize = coordinate.getSize(),
      _coordinate$getSize2 = _slicedToArray(_coordinate$getSize, 2),
      width = _coordinate$getSize2[0],
      height = _coordinate$getSize2[1];
    var polar = coordinate.getOptions().transformations.find(function (t) {
      return t[0] === 'polar';
    });
    // coordinate.size * outerRadius.
    if (polar) return Math.max(width, height) / 2 * polar[4];
  }
  return 0;
}
export function radiusOf(coordinate) {
  var _coordinate$getOption7 = coordinate.getOptions(),
    transformations = _coordinate$getOption7.transformations;
  var _transformations$find = transformations.find(function (d) {
      return d[0] === 'polar';
    }),
    _transformations$find2 = _slicedToArray(_transformations$find, 5),
    innerRadius = _transformations$find2[3],
    outerRadius = _transformations$find2[4];
  return [+innerRadius, +outerRadius];
}
export function angleOf(coordinate) {
  var isRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _coordinate$getOption8 = coordinate.getOptions(),
    transformations = _coordinate$getOption8.transformations;
  var _transformations$find3 = transformations.find(function (d) {
      return d[0] === 'polar';
    }),
    _transformations$find4 = _slicedToArray(_transformations$find3, 3),
    startAngle = _transformations$find4[1],
    endAngle = _transformations$find4[2];
  return isRadius ? [+startAngle * 180 / Math.PI, +endAngle * 180 / Math.PI] : [startAngle, endAngle];
}
export function getTransformOptions(coordinate, type) {
  var _coordinate$getOption9 = coordinate.getOptions(),
    transformations = _coordinate$getOption9.transformations;
  var _transformations$find5 = transformations.find(function (d) {
      return d[0] === type;
    }),
    _transformations$find6 = _toArray(_transformations$find5),
    args = _transformations$find6.slice(1);
  return args;
}